window.ohbInitMiniTravelMedia = function (options) {
  document.addEventListener("DOMContentLoaded", () => {
    const mediaGallery = document.querySelector("media-gallery");
    const productSection = document.querySelector(".product-variant-id");
    const sectionID = options.sectionId;
    const handle = `products/${options.productHandle}.js`;
    const optionsToWatch = (options.selectedOptionName || "").split(",");

    if (!mediaGallery || !productSection) {
      console.error("Required elements are missing from the DOM.");
      return;
    }

    fetch(`${window.Shopify.routes.root}${handle}`)
      .then((response) => response.json())
      .then((product) => {
        const colorOption =
          product.options.find((option) =>
            optionsToWatch.includes(option.name)
          ) || null;

        if (!colorOption) {
          console.warn("No relevant options available for this product.");
          return;
        }

        const colorValues = colorOption.values;
        const colorImagePositions = {};

        colorValues.forEach((color) => {
          const variant = product.variants.find(
            (variant) => variant.options[colorOption.position - 1] === color
          );

          if (variant && variant.featured_image) {
            colorImagePositions[color] = variant.featured_image.position;
          }
        });

        const sortedColors = Object.entries(colorImagePositions).sort(
          (a, b) => a[1] - b[1]
        );
        const colorImageRanges = {};

        sortedColors.forEach((color, index) => {
          const colorName = color[0];
          const startPos = color[1];
          const endPos = sortedColors[index + 1] ? sortedColors[index + 1][1] : null;

          colorImageRanges[colorName] = endPos ? [startPos, endPos] : [startPos];
        });

        const colorImageIDs = {};
        Object.entries(colorImageRanges).forEach(([color, range]) => {
          const startPos = range[0];
          const endPos = range[1] || product.media.length + 1;

          const imageIDs = product.media
            .filter((media, index) => {
              const imagePosition = index + 1;
              return imagePosition >= startPos && imagePosition < endPos;
            })
            .map((media) => media.id);

          colorImageIDs[color] = imageIDs;
        });

        Object.entries(colorImageIDs).forEach(([color, imageIDs]) => {
          imageIDs.forEach((mediaID) => {
            const selector = `[data-media-id="${sectionID}-${mediaID}"], [data-target="${sectionID}-${mediaID}"]`;
            const mediaItems = mediaGallery.querySelectorAll(`li${selector}`);

            mediaItems.forEach((mediaItem) => {
              mediaItem.setAttribute("data-media-group", color);
            });
          });
        });

        const showVariantImage = () => {
          const variantSelects = document.querySelector("variant-selects");
          if (!variantSelects) return;

          const currentValues = Array.from(
            variantSelects.querySelectorAll(
              "select option[selected], fieldset input:checked"
            )
          ).map((el) => el.value);

          const selectedColor = currentValues.find((value) =>
            Object.prototype.hasOwnProperty.call(colorImageRanges, value)
          );

          mediaGallery.querySelectorAll("ul li[data-media-group]").forEach((mediaItem) => {
            if (mediaItem.getAttribute("data-media-group") === selectedColor) {
              mediaItem.classList.remove("hidden");
            } else {
              mediaItem.classList.add("hidden");
            }
          });

          mediaGallery.querySelectorAll("slider-component").forEach((slider) => {
            if (typeof slider.initPages === "function") {
              slider.initPages();
            }
          });
        };

        showVariantImage();
        productSection.addEventListener("change", showVariantImage);
      })
      .catch((error) => console.error("Error fetching product data:", error));
  });
};